import React from 'react'
import "../../styles/MatchStatsFormCard.css"

export default function MatchStatsFormCard({ stats }) {
    // const formWon = stats.form.find(e => e.stat_key === "form_won");
    // const formLost = stats.form.find(e => e.stat_key === "form_lost");

    // const homeWins = formWon?.home_value ?? 0;
    // const awayWins = formWon?.away_value ?? 0;

    // const homeLost = formLost?.home_value ?? 0;
    // const awayLost = formLost?.away_value ?? 0;

    // const homeDraw = 5-homeLost-homeWins
    // const awayDraw = 5-awayLost-awayWins

    return (
        <div className='form-stat-card'>
            <div className='form-stat-title'>
                Előző 5 mérkőzés forma
            </div>

            <div className="form-stat-header">
                <img src={`/images/teams/${stats.teams.home.logo}`} alt={stats.teams.home.name} />
                <img src={`/images/teams/${stats.teams.away.logo}`} alt={stats.teams.away.name} />
            </div>

            <div className="form-stat-list">

                {stats.form.map((stat) => {
                    const homeBetter = stat.home_value >= stat.away_value;
                    const awayBetter = stat.away_value >= stat.home_value;

                    return (
                        <div className="form-stat-row">

                            <span className={`form-stat-value ${homeBetter ? "better" : "worse"}`} >
                                {stat.unit === "%"
                                    ? Math.trunc(stat.home_value) + stat.unit
                                    : stat.home_value + stat.unit
                                }
                            </span>

                            <span className='form-stat-label'>
                                {stat.label}
                            </span>

                            <span className={`form-stat-value ${awayBetter ? "better" : "worse"}`} >
                                {stat.unit === "%"
                                    ? Math.trunc(stat.away_value) + stat.unit
                                    : stat.away_value + stat.unit
                                }
                            </span>
                        </div>
                    )
                })}

            </div>
        </div>
    )
}
